import { PublicLinkStartingScreen } from './public-link-data.model';
import { PublicLinkStartingScreenDto, PublicLinkStartingScreenName } from './public-link-dto.model';

const BY_NAME: Readonly<Record<PublicLinkStartingScreenName, PublicLinkStartingScreen>> = {
  Devices: PublicLinkStartingScreen.widgets,
  Assets: PublicLinkStartingScreen.assets,
  Scenes: PublicLinkStartingScreen.scenes,
  Events: PublicLinkStartingScreen.events,
  Tickets: PublicLinkStartingScreen.tickets
};

export type PublicLinkPanelContext = keyof typeof PublicLinkStartingScreen;

/** Maps the backend value (string, or the numeric form from swagger) to the frontend enum; defaults to Devices. */
export function toPublicLinkStartingScreen(
  value: PublicLinkStartingScreenDto | null | undefined
): PublicLinkStartingScreen {
  if (typeof value === 'number') {
    return PublicLinkStartingScreen[value] !== undefined ? value : PublicLinkStartingScreen.widgets;
  }
  return (value && BY_NAME[value]) ?? PublicLinkStartingScreen.widgets;
}

/** The space viewer panel context matching a starting screen. */
export function startingScreenToPanelContext(screen: PublicLinkStartingScreen): PublicLinkPanelContext {
  return PublicLinkStartingScreen[screen] as PublicLinkPanelContext;
}
